// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "modal__root-2rET6";
var _3 = "modal__paper-1L-kI";
var _4 = "aggregator__cover-1oNPb";
export { _1 as "__esModule", _2 as "modal__root", _3 as "modal__paper", _4 as "aggregator__cover" }
export default { "__esModule": _1, "modal__root": _2, "modal__paper": _3, "aggregator__cover": _4 }
